// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606231139/js/" + chunkId + "." + {"44":"71751b98","225":"391664a9","481":"4f8bb364","486":"fc4dd757","770":"3f0e871d"}[chunkId] + ".0.980684431038092.chunk.js";
};